export const healthEn = {
  title: "System health",
  integrations: "Integrations",
  jobs: "Scheduled jobs",
  pending_actions: "Pending automated actions",
  failed_runs: "Failed runs (7 days)",
  sync_now: "Sync now",
  syncing: "Syncing…",
  sync_done: "Sync started.",
  sync_failed: "Sync failed.",
  sync_forbidden: "Access denied: administrators only.",
  sync_server_error: "Sync failed (code: %{code}).",
  storage_purge: "Failed file deletions",
  late: "Late",
  ok: "OK",
  error: "Error",
  never: "Never",
  never_run: "Never run",
  none: "Nothing to report",
  // GAVION full-email: the content queue on the gavion-graph-sync:content row
  content_backlog:
    "%{smart_count} email waiting — oldest for %{minutes} min |||| %{smart_count} emails waiting — oldest for %{minutes} min",
  statuses: {
    late: "Late",
    failing: "Failing",
    ok: "OK",
    connected: "Connected",
    error: "Error",
    disconnected: "Disconnected",
    needs_reauth: "Reconnection required",
  },
  skipped: {
    ai_not_configured: "AI key missing: no draft written",
  },
  codes: {
    network: "Network unavailable",
    timeout: "Timed out",
    unknown: "Unknown error",
    forbidden: "Access denied",
    http: "HTTP error %{status}",
    db: "Database error (%{code})",
    invalid_credentials: "Invalid VoIP.ms credentials",
    ip_not_enabled: "IP not authorized at VoIP.ms",
    purge_failed: "Some files could not be deleted",
    retention_failed: "The retention job failed",
    job_run_write_failed: "Could not record the job run",
  },
  columns: {
    bucket: "Bucket",
    source: "Source",
    name: "Name",
    status: "Status",
    last_run: "Last run",
    last_success: "Last success",
    last_error: "Last error",
    failures: "Consecutive failures",
    due: "Due",
    type: "Type",
    attempts: "Attempts",
    rule: "Rule",
    date: "Date",
  },
};
